// Module
var code = "<div> <div class=\"contextual-menu hidden-print migrated\"> <wt-contextual-control item=\"vm.configuration\" fields=\"vm.properties\" has-property-types=\"true\" save=\"vm.onSave()\" on-cancel=\"vm.onCancel()\" form-controller=\"vm.formController\" modern-design=\"true\"> </wt-contextual-control> </div> </div>";
// Exports
module.exports = code;